'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Details": "Polaris-ActionMenu-MenuGroup__Details"
};

exports.default = styles;
